import { useState, useEffect } from 'react';
import api from '../../services/api';

export const useToolLibrary = () => {
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTools = async () => {
      try {
        setLoading(true);
        const response = await api.get('/admin/resources/tools');
        setTools(response.data.data);
        setError(null);
      } catch (err) {
        setError(err);
        console.error('Error fetching tools:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTools();
  }, []);

  return { tools, loading, error };
};
